import { getRandomAlphaNumString, isEmpty } from '@jfs/utils'
import { Instance, flow, types } from 'mobx-state-tree'
import { Routes } from '../../nav/routes'
import { checkStatus as fetchStatus } from '../../network/checkStatus'
import { exportFile } from '../../network/exportFile'
import { exportSingleTxnReqV3 } from '../../network/exportSingleTxnReqV3'
import { extendAppSessionAPI } from '../../network/extendAppSession'
import { extendUserSessionAPI } from '../../network/extendUserSession'
import { getRefundDetailsV3 } from '../../network/getRefundDetailsV3'
import { getSplitSettlementDetails } from '../../network/getSplitSettlementDetails'
import { getSummaryV3 } from '../../network/getSummaryV3'
import { getTxnDetailsV3 } from '../../network/getTxnDetailsV3'
import { getTxnsColumnV3 } from '../../network/getTxnsColumnV3'
import { initRefund } from '../../network/initRefund'
import { getRefundsReqV3, getSearchByRefundList } from '../../network/refundsTxnV3'
import { splitSettlements } from '../../network/splitSettlements'
import { transactionReqV3 } from '../../network/transactionReqV3'
import {
  DateFormatTypes,
  ENABLE_CSV,
  FILE_DOWNLOADED,
  FILE_DOWNLOAD_INPROCESS,
  OTHER_FORMAT_FILE_DOWNLOAD_INPROCESS,
  SESSION_EXPIRED,
  dateFormatter,
  dateToLocaleISO,
  downloadFile,
  fromDateTime,
  getEndDate,
  getHHMMSS,
  getRefundSource,
  getSelectedDate,
  getStartEndDateTimeFromDate,
  isOsMobile,
  isSmallDevice,
  toDateTime,
} from '../../util/util'
import {
  initRefundsTableParser,
  refundConfirmTableParser,
  refundHistoryParser,
  refundInitiateTableParser,
  refundMobileTableParser,
  refundStatusParser,
  refundsRecentsTableParser,
  transactionFilterMobileTableParser,
  transactionFilterTableParserNew,
  transactionRecentsTableParse,
} from '../parser/view/TableParser'
import { transactionDetailsParser } from '../parser/view/transactionDetailsParser'
import { txnDetailsMobileParser } from '../parser/view/txnDetailsMobileParser'
import { getRefundV3Body, getTransactionV3RequestBody } from '../request/requestbody'
import {
  REFUND_FIELD_SETTINGS,
  REFUND_FIELD_SETTINGS_DATA,
  defaultFields,
  exportType,
  initRefundTableFields,
  initiateRefundStatusDataV2,
  initiateRefundTitleDataSodexoV2,
  initiateRefundTitleDataV2,
  mimeTypes,
  paginationSettings,
  paginationSettingsWithDefaultPage1,
  refundsProcessedTitleData,
} from '../static/data'
import { BENEFICIARY_ENTITY_TYPE, PLATFORM_FEE_ENTITY_TYPE, actionMenuStrings, customError } from '../static/strings'
import { RootStore } from '../store'
import { INFINITE_SCROLL_WINDOW_INDEX } from './../../util/common'
import { Filters, defaultSelectedFilters } from './Filters'
import {
  Pagination,
  RefundHistory,
  RefundProcessed,
  ResponseType,
  Transaction,
  TransactionTypes,
  TransasctionApiType,
} from './Transaction'

const getFilterKeyForRequest: any = {
  'Merchant Ref No.': 'invoice',
  'JioPay Id': 'transactionId',
  'Bank ref No.': 'bankReferenceNumber',
  'Customer Id': 'customerId',
  'Mobile Number': 'mobileNumber',
  Email: 'email',
  'Udf 1': 'udf1',
  'Udf 2': 'udf2',
  'Udf 3': 'udf3',
  'Udf 4': 'udf4',
  'Udf 5': 'udf5',
  'Terminal Id': 'terminalId',
  'Offer Code': 'offerCode',
  'Settlement RefNumber': 'settlementRefNumber',
  'Account Number': 'accountNumber',
}

export const FieldSetting = types.model('FieldSetting', {
  id: types.string,
  isChecked: types.boolean,
  title: types.string,
  isDisable: types.optional(types.boolean, false),
})

const Position = types.model('position', {
  left: types.number,
  top: types.number,
  visible: types.boolean,
})

const DateRange = types.model('date', {
  fromDate: types.optional(types.union(types.Date, types.string, types.null), ''),
  toDate: types.optional(types.union(types.Date, types.string, types.null), ''),
  position: Position,
  dateLabel: types.optional(types.string, ''),
})

const nextNestedObj = types.map(
  types.union(types.string, types.number, types.boolean, types.array(RefundHistory), types.null),
)
const nestedObj = types.map(
  types.union(types.string, types.number, types.boolean, types.null, types.array(RefundHistory), nextNestedObj),
)

export const transactionMap = types.map(
  types.union(types.string, types.number, types.boolean, types.null, types.array(RefundHistory), nestedObj),
)

const Transactions = types
  .model('Transactions', {
    history: types.array(transactionMap),
    todaysRecived: types.array(Transaction),
    todaysRefunded: types.array(Transaction),
    received: types.array(Transaction),
    refunded: types.array(Transaction),
    pagination: Pagination,
    paginationRecived: Pagination,
    paginationRefunded: Pagination,
    filter: Filters,
    receivedFilter: Filters,
    refundFilter: Filters,
    fieldSetting: types.array(FieldSetting),
    selectedTxn: types.optional(types.string, ''),
    details: types.maybe(Transaction),
    selectedDateInfo: DateRange,
    receivedSelectedDateInfo: DateRange,
    refundedSelectedDateInfo: DateRange,
    exportStatementDateInfo: DateRange,
    todaysSuccessfulTxnsAmt: types.optional(types.string, ''),
  })
  .actions((self) => ({
    getTransactionsV3: flow(function* getTransactionsV3(
      curentPage,
      pageSize,
      sortPageBy,
      fromDate,
      toDate,
      mid,
      mediaType,
      idempotentKeyArr,
      referenceNumberArr,
      invoiceArr,
      transactionIdsArr,
      sourceSystem,
      email,
      mobileNumber,
      _isLoadMore = false,
      transactionTabName,
      restrictTransactionCount,
      isCustomFromRecent = false,
      selectedDateInfo = RootStore.transactions.selectedDateInfo,
      isRecent = false,
      isMobile = false,
      abortController,
    ) {
      const fields = RootStore.transactions.getCheckedColumn()
      const searchString = RootStore.settings.metaData.searchString
      const filter = isMobile ? self.receivedFilter : self.filter
      const requestBody = getTransactionV3RequestBody({
        merchantId: mid,
        startDateTime: fromDate,
        endDateTime: toDate,
        transactionType: TransasctionApiType.transaction,
        responseType: fields.length < 1 && !isSmallDevice() ? ResponseType.DEFAULT : ResponseType.CUSTOM,
        outputDomains:
          fields.length > 1 || !isSmallDevice()
            ? [...fields, 'essStatus', 'refundAmount']
            : [
                'transactionDateTime',
                'invoice',
                'transactionId',
                'transactionAmount',
                'transactionDisposition',
                'cardType',
                'paymentType',
                'issRefData',
                'customerName',
              ],
        paymentMethods: filter.paymentMode,
        transactionStatus: filter.transactionStatus,
        page: curentPage,
        recordCount: pageSize,
        sortType: sortPageBy.slice(sortPageBy.indexOf(',') + 1),
        sortColumn: sortPageBy.slice(0, sortPageBy.indexOf(',')),
        minimumTransactionAmount: filter.min,
        maximumTransactionAmount: filter.max,
        mediaType: mediaType,
        idempotentKey: idempotentKeyArr,
        referenceNumber: referenceNumberArr,
        invoice: invoiceArr,
        transactionId: transactionIdsArr,
        sourceSystem: sourceSystem,
        email: email,
        mobileNumber: mobileNumber,
        searchString: searchString,
        searchKey: getFilterKeyForRequest[RootStore.settings.metaData.searchFilterItem],
        subMids: RootStore.user.isSmid ? self.filter.mid : undefined,
        isSmid: RootStore.user.isSmid,
        isRecent,
        abortController,
      })
      let response
      try {
        const parsedTxn = yield transactionReqV3(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          requestBody,
          TransactionTypes.Transaction,
          restrictTransactionCount,
          isCustomFromRecent,
          transactionTabName,
          selectedDateInfo,
          abortController,
        )
        if (transactionTabName === 'Transactions') {
          self.paginationRecived = JSON.parse(JSON.stringify(parsedTxn?.page))
          self.received = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.received, ...parsedTxn.transaction]))
            : JSON.parse(JSON.stringify(parsedTxn.transaction))
          return parsedTxn
        } else if (transactionTabName === 'Home') {
          self.todaysRecived = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.todaysRecived, ...parsedTxn.transaction]))
            : JSON.parse(JSON.stringify(parsedTxn.transaction))
        } else {
          self.pagination = JSON.parse(JSON.stringify(parsedTxn?.page))
          self.history = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.history, ...parsedTxn.transaction]))
            : JSON.parse(JSON.stringify(parsedTxn.transaction))
        }
      } catch (e) {
        const isCancelled = e?.data?.errorCode === 'ERR_CANCELED'
        if (!_isLoadMore && !isCancelled) {
          self.history = JSON.parse(JSON.stringify([]))
          self.pagination = paginationSettingsWithDefaultPage1
        }
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    getSearchResultsTxnV3: flow(function* getSearchResultsTxnV3(mid, searchString, type, txnType, extraReqParams = {}) {
      const fields = RootStore.transactions.getCheckedColumn()
      const pageNumber = self.pagination.number === 0 ? 1 : self.pagination.number
      const size = self.pagination.size < 10 ? 10 : self.pagination.size
      const requestBody = getTransactionV3RequestBody({
        merchantId: mid,
        transactionType: txnType ?? TransasctionApiType.transaction,
        searchString: searchString,
        mediaType: 'JSON',
        isSearchApi: true,
        page: pageNumber,
        recordCount: size,
        searchKey: getFilterKeyForRequest[RootStore.settings.metaData.searchFilterItem],
        responseType:
          type === 'initrefund' ? ResponseType.CUSTOM : fields.length < 1 ? ResponseType.DEFAULT : ResponseType.CUSTOM,
        outputDomains: type === 'initrefund' ? initRefundTableFields : fields,
        subMids: RootStore.user.isSmid ? self.filter.mid : undefined,
        isSmid: RootStore.user.isSmid,
        ...extraReqParams,
      })
      try {
        const parsedTxn = yield transactionReqV3(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          requestBody,
          TransactionTypes.Transaction,
          false,
          false,
        )
        const history = JSON.parse(JSON.stringify([...parsedTxn.transaction]))
        self.history = history
        self.pagination = JSON.parse(JSON.stringify(parsedTxn?.page))
      } catch (error) {
        RootStore?.response?.setMessage(error?.data?.error?.message ?? customError.errorOccured)
        throw new Error(error?.data?.error?.message ?? 'Error while processing request')
      }
    }),
    getSearchByRefundIdList: flow(function* getSearchByRefundIdList(mid, transactionId, trxType) {
      let rrn = transactionId ?? ''
      try {
        const responseTxn = yield getSearchByRefundList(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          rrn,
          TransasctionApiType.refunds,
          mid,
          trxType,
          RootStore.user.isSmid,
        )
        self.history = responseTxn?.refunds
        self.pagination = JSON.parse(JSON.stringify(responseTxn?.page))
      } catch (e) {
        console.log('Error: ', e)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
    }),

    getSplitStatusAndTransactions: flow(function* (transactionId, transactionDate, trxType, refundId) {
      try {
        const isSplitAllowedFOrMid = RootStore.settings.metaData.isSplitSettlementsEnabled && !RootStore.user.isSmid
        const parsedTxn = self.details
        if (
          parsedTxn?.status === 'SUCCESS' &&
          isSplitAllowedFOrMid &&
          (isEmpty(parsedTxn?.essStatus) || parsedTxn?.essStatus === 'PAYOUT_SPLIT_INITIATED')
        ) {
          const getTrxType: any = {
            transactions: TransactionTypes.Transaction,
            refunds: TransactionTypes.Refund,
          }
          const txnType = getTrxType[trxType] ?? TransactionTypes.Refund
          const { startDateTime, endDateTime } = getStartEndDateTimeFromDate(transactionDate)
          const splitDetailsReq = {
            inputFilter: {
              startDateTime: startDateTime,
              endDateTime: endDateTime,
              originalTransactionId: txnType === 'REFUND' ? [refundId] : [transactionId],
              // methodType: ['423'],
              // methodSubType: ['421'],
            },
            configParams: {
              mediaType: 'JSON',
              page: 1,
              size: 10,
            },
            outputDomains: [
              'created',
              'settlementNetAmount',
              'status',
              'payoutSequenceNumber',
              'originalTransactionId',
              'jiopayOrigTransactionId',
              'merchantId',
              'payoutInitiatedDate',
              'payoutDate',
              'groupId',
              'subGroupId',
              'transactionMode',
              'settlementGrossAmount',
              'payoutTransactionId',
            ],
          }
          const splitDetailsResponse = yield getSplitSettlementDetails(
            splitDetailsReq,
            RootStore.user.session.getTokens,
            RootStore.user.session.userAccessToken,
          )

          if (splitDetailsResponse?.length > 0) {
            const ownTxn = splitDetailsResponse?.find((item) => item?.transactionMode !== '25')
            parsedTxn.essSettlementGrossAmount = +ownTxn.settlementGrossAmount
            if (ownTxn?.status === 'PAYOUT_SPLIT_STAGED') {
              parsedTxn.essStatus = 'PAYOUT_SPLIT_STAGED'
              self.details = JSON.parse(JSON.stringify(parsedTxn))
            } else if (ownTxn?.status === 'PAYOUT_SPLIT_INITIATED') {
              parsedTxn.essStatus = 'PAYOUT_SPLIT_INITIATED'
              self.details = JSON.parse(JSON.stringify(parsedTxn))
              if (ownTxn?.splitTxnIds?.length > 0) {
                const splitTxnsReq = {
                  inputFilter: {
                    startDateTime: startDateTime,
                    endDateTime: getEndDate(transactionDate),
                    originalTransactionId: [ownTxn?.splitTxnIds],
                  },
                  configParams: {
                    mediaType: 'JSON',
                    page: 1,
                    size: 10,
                  },
                  outputDomains: [
                    'created',
                    'settlementNetAmount',
                    'status',
                    'payoutSequenceNumber',
                    'originalTransactionId',
                    'jiopayOrigTransactionId',
                    'merchantId',
                    'payoutInitiatedDate',
                    'payoutDate',
                    'groupId',
                    'subGroupId',
                    'transactionMode',
                    'settlementGrossAmount',
                  ],
                }
                const splitTxnsResponse = yield getSplitSettlementDetails(
                  splitTxnsReq,
                  RootStore.user.session.getTokens,
                  RootStore.user.session.userAccessToken,
                )
                if (splitTxnsResponse?.status === 'FAILED') {
                  throw { message: splitTxnsResponse?.message ?? 'Error while processing request', errSection: 'split' }
                } else {
                  const splitTxns = splitTxnsResponse?.filter((item) => item?.transactionMode === '25')
                  parsedTxn.splitTxns = JSON.parse(JSON.stringify(splitTxns))
                  self.details = JSON.parse(JSON.stringify(parsedTxn))
                }
              }
            }
          }
        }
      } catch (e) {
        throw e?.errSection ? e : new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
    }),

    getTransactionDetailsV3: flow(function* getTransactionDetailsV3(mid, transactionId, transactionDate, trxType) {
      self.details = undefined
      const getTrxType: any = {
        transactions: TransactionTypes.Transaction,
        refunds: TransactionTypes.Refund,
      }
      let rrn = transactionId ?? ''
      const txnType = getTrxType[trxType] ?? TransactionTypes.Refund
      let responseRefunds
      try {
        const responseTxn = yield getTxnDetailsV3(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          rrn,
          TransasctionApiType.transaction,
          mid,
          txnType,
          RootStore.user.isSmid,
          trxType === 'transactions' ? transactionDate : undefined,
        )
        const parsedTxn = responseTxn
        self.details = JSON.parse(JSON.stringify(parsedTxn))
        responseRefunds = yield getRefundDetailsV3(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          rrn,
          TransasctionApiType.refunds,
          mid,
          txnType,
          RootStore.user.isSmid,
        )
        const parsedRefundsHistory = responseRefunds
        parsedTxn.refundHistory = parsedRefundsHistory
        self.details = JSON.parse(JSON.stringify(parsedTxn))

        return responseRefunds
      } catch (e) {
        throw e?.errSection ? e : new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
    }),
    getRefundsTxnsV3: flow(function* getRefundsTxnsV3(
      curentPage,
      pageSize,
      sortPageBy,
      fromDate,
      toDate,
      mid,
      _isLoadMore = false,
      transactionTabName,
      isCustomFromRecents = false,
      isRecent = false,
      ismobile = false,
      abortController = null,
    ) {
      const fields = RootStore.transactions.getCheckedColumn()
      const isSmid = RootStore.user.isSmid
      const filter = ismobile ? self.refundFilter : self.filter
      const getRefundFilterParams = getRefundV3Body(
        mid,
        fromDate,
        toDate,
        self,
        curentPage,
        fields,
        isSmid,
        isRecent,
        filter,
      )
      let response
      const dateObject =
        self?.refundFilter?.selectedDateInfo?.fromDate && self?.refundFilter?.selectedDateInfo?.toDate
          ? self?.refundFilter?.selectedDateInfo
          : self?.refundedSelectedDateInfo
      try {
        response = yield getRefundsReqV3(
          RootStore.user.session.getTokens,
          RootStore.user.session.userAccessToken,
          getRefundFilterParams,
          TransactionTypes.Refund,
          isCustomFromRecents,
          transactionTabName,
          dateObject,
          abortController,
        )
        const { page, refunds } = response
        if (transactionTabName === 'Transactions') {
          self.paginationRefunded = JSON.parse(JSON.stringify(page))
          self.refunded = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.refunded, ...refunds]))
            : JSON.parse(JSON.stringify(refunds))
        } else if (transactionTabName === 'Home') {
          self.todaysRefunded = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.todaysRefunded, ...refunds]))
            : JSON.parse(JSON.stringify(refunds))
        } else {
          self.pagination = JSON.parse(JSON.stringify(page))
          self.history = _isLoadMore
            ? JSON.parse(JSON.stringify([...self.history, ...refunds]))
            : JSON.parse(JSON.stringify(refunds))
        }
        // Fix for multiple calls on quickly paginating
      } catch (e) {
        const isCancelled = e?.data?.errorCode === 'ERR_CANCELED'
        if (!isCancelled && !_isLoadMore) {
          self.history = JSON.parse(JSON.stringify([]))
          self.pagination = paginationSettingsWithDefaultPage1
        }
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    getTransactionsColumnV3: flow(function* getTransactionsColumnV3() {
      let response
      try {
        response = yield getTxnsColumnV3(RootStore.user.session.getTokens, RootStore.user.session.userAccessToken)
        const parsedColumn = response
        self.fieldSetting = JSON.parse(JSON.stringify([...parsedColumn]))
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    fetchStatsV3: flow(function* fetchStatsV3(mid: string) {
      let response
      const dateInfo = {
        fromDate: getSelectedDate(1),
        toDate: new Date(Date.now()),
        position: {
          top: 0,
          left: 0,
          visible: false,
        },
        dateLabel: 'Today',
      }
      const filteredFromDate = dateInfo?.fromDate ?? new Date(Date.now())

      const formattedFilteredFromData = `${dateFormatter(filteredFromDate, DateFormatTypes.YYYYMMDD)}${getHHMMSS(
        filteredFromDate,
      )}`
      const filteredEndDate = dateInfo?.toDate ?? new Date(Date.now())
      const formattedFilteredToData = `${dateFormatter(filteredEndDate, DateFormatTypes.YYYYMMDD)} ${getHHMMSS(
        filteredEndDate,
      )}`
      const txnReq = {
        inputFilter: {
          merchantId: mid,
          transactionType: 'PURCHASE',
          startDateTime: formattedFilteredFromData,
          endDateTime: formattedFilteredToData,
          isSMID: RootStore.user.isSmid ? 'Y' : 'N',
        },
      }
      try {
        response = yield getSummaryV3(
          RootStore.user.session.getTokens,
          RootStore.settings.metaData.mobileNumber,
          txnReq,
          'transactions',
          false,
          dateInfo,
        )
        self.todaysSuccessfulTxnsAmt = response?.successfulTxnsAmt ?? ''
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    updatePaginationTxn(selectedPage: number): void {
      self.pagination.number = selectedPage
    },
    updateSelectedDateInfo(dateObj: any): void {
      self.selectedDateInfo.fromDate = dateObj?.fromDate ?? new Date(Date.now())
      self.selectedDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      self.selectedDateInfo.position.top = dateObj?.position?.top ?? 0
      self.selectedDateInfo.position.left = dateObj?.position?.left ?? 0
      self.selectedDateInfo.position.visible = dateObj?.position?.visible ?? false
      self.selectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
    },
    updateExportStatementDateInfo(dateObj: any): void {
      self.exportStatementDateInfo.fromDate = dateObj?.fromDate ?? new Date(new Date().setHours(0, 0, 0, 0))
      self.exportStatementDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      self.exportStatementDateInfo.position.top = dateObj?.position?.top ?? 0
      self.exportStatementDateInfo.position.left = dateObj?.position?.left ?? 0
      self.exportStatementDateInfo.position.visible = dateObj?.position?.visible ?? false
      self.exportStatementDateInfo.dateLabel = dateObj?.dateLabel ?? actionMenuStrings.today
    },
    updateRefundedSelectedDateInfo(dateObj: any): void {
      self.refundedSelectedDateInfo.fromDate = dateObj?.fromDate ?? new Date(Date.now())
      self.refundedSelectedDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      self.refundedSelectedDateInfo.position.top = dateObj?.position?.top ?? 0
      self.refundedSelectedDateInfo.position.left = dateObj?.position?.left ?? 0
      self.refundedSelectedDateInfo.position.visible = dateObj?.position?.visible ?? false
      self.refundedSelectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
    },
    updateReceivedSelectedDateInfo(dateObj: any): void {
      self.receivedSelectedDateInfo.fromDate = dateObj?.fromDate ?? new Date(Date.now())
      self.receivedSelectedDateInfo.toDate = dateObj?.toDate ?? new Date(Date.now())
      self.receivedSelectedDateInfo.position.top = dateObj?.position?.top ?? 0
      self.receivedSelectedDateInfo.position.left = dateObj?.position?.left ?? 0
      self.receivedSelectedDateInfo.position.visible = dateObj?.position?.visible ?? false
      self.receivedSelectedDateInfo.dateLabel = dateObj?.dateLabel ?? ''
    },
    updateSelectedRefundAmount(transactionId: string, amount: string): void {
      const retData: any = []
      self.history.map((item: any) => {
        if (item.get('transactionId') === transactionId) {
          retData.push({
            ...JSON.parse(JSON.stringify(item)),
            processed: amount,
          })
        } else {
          retData.push(item)
        }
      })
      self.history = JSON.parse(JSON.stringify([...retData]))
    },
    updateSelectedTxn(rrn: string): void {
      self.selectedTxn = rrn
    },
    updateRefundRequested(amount: string): void {
      const value = amount
      if (self.details) {
        self.details.refund.processed = value
      }
    },
    updateRefundInvoiceId(id: string): void {
      const value = id
      if (self.details) {
        self.details.refund.invoiceId = value
      }
      const selectedTxn = self?.history?.filter((item: any) => self?.selectedTxn === item?.rrn)?.[0]
      if (selectedTxn) {
        selectedTxn.refund.invoiceId = value
      }
    },
    updateRefundStatus(status: string): void {
      const value = status
      if (self.details) {
        self.details.refund.status = value
      }
    },

    initiateRefunds: flow(function* initiateRefunds(requestdata: any[]) {
      const refundData = requestdata[1]

      const selectedRrn = RootStore.transactions.getSlectedRRNs()
      const selectedTxn: any = self.history.filter((item: any) => selectedRrn === item.get('transactionId'))?.[0]
      const req = {
        source: getRefundSource(
          !isEmpty(selectedTxn?.get('sourceSystem'))
            ? selectedTxn?.get('sourceSystem')
            : self?.details?.refund?.sourceSystem,
        ),
        mid: RootStore.user.selectedMid,
        terminalId: RootStore.user.selectedTid,
        transactionTime: refundData?.date,
        rrn: refundData?.rrn,
        // acquiringInstId: "2121",
        // originalId: refundData?.id, //removed as per request from Sujit
        currency: 356,
        amount: !isEmpty(selectedTxn?.get('processed')) ? selectedTxn?.get('processed') : refundData?.refundProcess,
        invoice: refundData?.refundInvoiceId ?? self.details?.ern ?? '',
        livemode: 'true', // Added as per request from Sujit
      }
      let response
      try {
        response = yield initRefund(RootStore.user.session.getTokens, RootStore.user.session.userAccessToken, req)
        RootStore.transactions.updateRefundStatus(response?.data?.data?.status ?? 'FAILED')
        // return listResponse
      } catch (e) {
        RootStore.transactions.updateRefundStatus('FAILED') // As api fails updating status to FAILED
        RootStore?.response?.setMessage(e?.message ?? customError.errorOccured) // To show API error message in Toast
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),

    initiateSingleRefund: flow(function* initiateSingleRefund(amount: string, invoiceId: string) {
      const refundAmt = parseFloat(amount).toFixed(2)
      const req = {
        source: getRefundSource(self?.details?.refund?.sourceSystem),
        mid: RootStore.user.selectedMid,
        terminalId: RootStore.user.selectedTid,
        transactionTime: self.details?.date?.split('*')[1], //new Date(date),
        rrn: self.details?.originalTransactionId === '' ? self.details?.id : self.details?.originalTransactionId,
        // acquiringInstId: "2121",
        originalId: self.details?.originalTransactionId === '' ? self.details?.id : self.details?.originalTransactionId,
        currency: 356,
        amount: Number(refundAmt),
        invoice: isEmpty(invoiceId) ? self.details?.ern ?? '' : invoiceId,
      }
      let response
      try {
        response = yield initRefund(RootStore.user.session.getTokens, RootStore.user.session.userAccessToken, req)
        RootStore.transactions.updateRefundStatus(response?.data?.data?.status ?? 'FAILED')
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    exportFilesTxnV3: flow(function* exportFilesTxnV3(type, path, selectedDateInfo) {
      const fields = RootStore.transactions.getCheckedColumn()
      let txntype = path === Routes.TRANSACTIONS ? TransasctionApiType.transaction : TransasctionApiType.refunds
      const mid = RootStore.user.selectedMid
      const toDate =
        toDateTime(selectedDateInfo?.toDate ?? new Date(Date.now())) ??
        toDateTime(RootStore.settings.metaData.selectedDate.toDate ?? new Date(Date.now()))
      const fromDate =
        fromDateTime(selectedDateInfo?.fromDate) ?? fromDateTime(RootStore.settings.metaData.selectedDate.fromDate)
      // const toDate = toDateTime(RootStore.settings.metaData.selectedDate.toDate ?? new Date(Date.now()))
      // const fromDate = fromDateTime(RootStore.settings.metaData.selectedDate.fromDate)
      const enDate = +toDate > Date.now() ? Date.now() - 300000 : toDate // 5 min before txn
      const pMethod = self.filter.paymentMode.filter((item: any) => item !== 'ALL')
      const tStatus = self.filter.transactionStatus
        .filter((item: any) => item !== 'ALL')
        .map((item: any) => item.toUpperCase())

      const min = +self.filter.min === 0 ? null : +self.filter.min
      const max = +self.filter.max === 0 ? null : +self.filter.max

      const req = {
        inputFilter: {
          merchantId: mid,
          responseType: path === Routes.TRANSACTIONS ? ResponseType.CUSTOM : ResponseType.DEFAULT,
          startDateTime: fromDate, //dateFormatter(fromDate, DateFormatTypes.DATE_LOCAL),
          endDateTime: `${enDate}`,
          transactionType: txntype,
          paymentMethods: pMethod,
          status: tStatus,
          minimumTransactionAmount: min,
          maximumTransactionAmount: max,
          isSMID: RootStore.user.isSmid ? 'Y' : 'N',
          subMerchantId: RootStore.user.isSmid && self.filter.mid.length > 0 ? self.filter.mid[0] : undefined,
        },
        configParams: {
          mediaType: exportType.get(type),
          sortColumn: 'transactionDateTime',
          sortType: 'DESC',
        },
        outputDomains: isOsMobile() ? defaultFields : fields,
      }
      console.log('exportFilesTxnV3', { req })
      let resp
      try {
        if (isOsMobile()) {
          resp = yield exportFile(RootStore.user.session.getTokens, req, mid, selectedDateInfo?.dateLabel)
          try {
            if (resp?.code === FILE_DOWNLOADED) {
              return resp
            } else if (resp?.code === FILE_DOWNLOAD_INPROCESS || resp?.code === OTHER_FORMAT_FILE_DOWNLOAD_INPROCESS) {
              if (ENABLE_CSV && resp?.code === OTHER_FORMAT_FILE_DOWNLOAD_INPROCESS) {
                RootStore.reports.setMessage(
                  `We're working on the report you requested. You can access it in ${resp?.fileType} format here after it is generated`,
                )
              } else {
                RootStore.reports.setMessage(
                  "We're working on the report you requested. You can access it here after it is generated",
                )
              }
              return resp
            } else if (resp?.code === SESSION_EXPIRED) {
              yield extendAppSessionAPI()
              yield extendUserSessionAPI()
              return yield (self as any).exportFilesTxnV3(type, path, selectedDateInfo)
            } else {
              RootStore?.response?.setMessage('Error while exporting')
            }
          } catch (e) {
            console.log('Error while exporting', e)
          }
        } else {
          resp = yield exportFile(RootStore.user.session.getTokens, req)
          const contentType = resp.headers.get('content-type')
          if (contentType === 'application/json' || !contentType) {
            resp = yield resp.json()
            if (resp?.status === 'SUCCESS' && resp?.data?.status === 'INPROCESS') {
              const mediaType = resp?.data?.mediaType?.replace('.', '')
              if (ENABLE_CSV && mediaType !== type) {
                RootStore.reports.setMessage(
                  `Your report will be available in the 'Downloads' section in some time in ${mediaType} format .`,
                )
              } else {
                RootStore.reports.setMessage("Your report will be available in the 'Downloads' section in some time.")
              }
            } else if (resp?.status === 'SUCCESS' && resp?.data?.status === 'FAILED') {
              RootStore?.response?.setMessage('Export file failed')
            } else if (resp.status === 'FAILURE' && resp.error.code === '33306') {
              yield extendAppSessionAPI()
              yield extendUserSessionAPI()
              return (self as any).exportFilesTxnV3(type, path, selectedDateInfo)
            } else if (resp.status === 'FAILURE' && resp.error.code === '33607') {
              yield extendUserSessionAPI()
              return (self as any).exportFilesTxnV3(type, path, selectedDateInfo)
            } else {
              RootStore?.response?.setMessage(resp.error?.message ?? customError.errorOccured)
            }
          } else {
            downloadFile(resp, null)
          }
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.message ?? customError.errorOccured)
      }
      return resp
    }),
    exportSingleTxnV3: flow(function* exportSingleTxnV3(type, path, mid, transactionId) {
      let txntype = path === Routes.TRANSACTIONS ? TransasctionApiType.transaction : TransasctionApiType.refunds
      const reqBody = {
        inputFilter: {
          merchantId: mid,
          isSMID: RootStore.user.isSmid ? 'Y' : 'N',
          subMerchantId: RootStore.user.isSmid && self.filter.mid.length > 0 ? self.filter.mid[0] : undefined,
          transactionType: txntype,
          originalTransactionId: [transactionId],
        },
        configParams: {
          mediaType: exportType.get(type),
          sortColumn: 'transactionDateTime',
        },
      }
      let resp
      try {
        resp = yield exportSingleTxnReqV3(RootStore.user.session.getTokens, reqBody)
        if (window) {
          let mimeType = resp.headers['content-type']
          //check for undefined file download on session expire
          if (mimeTypes.get(mimeType) === undefined) {
            return
          }
          let fileInfo = resp.headers['content-disposition']
          const fileName = fileInfo?.slice(fileInfo.indexOf('=') + 1, fileInfo.lastIndexOf('.')) ?? 'file'

          const blob = new Blob([resp?.data], {
            mimeType,
          })
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = fileName + `${mimeTypes.get(mimeType)}`
          a.className = 'fileDownloadClass'
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
          if (ENABLE_CSV && mimeTypes.get(mimeType)?.toUpperCase().replace('.', '') !== exportType.get(type)) {
            RootStore?.response?.setMessage('Downloading the file in csv format')
          }
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? 'Error while processing request')
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return resp
    }),
    checkStatus: flow(function* checkStatus(txnId: string) {
      let response
      try {
        response = yield fetchStatus(RootStore.user.session.getTokens, RootStore.settings.metaData.mobileNumber, txnId)
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return { status: response?.transactionList[0]?.transaction?.status?.toLowerCase() ?? 'pending', data: response }
    }),

    pollStatus: flow(function* pollStatus(txnId: string) {
      let response
      try {
        response = yield fetchStatus(RootStore.user.session.getTokens, RootStore.settings.metaData.mobileNumber, txnId)
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return { status: response?.transactionList[0]?.transaction?.status?.toLowerCase() ?? 'pending', data: response }
    }),
    createSplitSettlements: flow(function* createSplitSettlements(
      txnId: string,
      paymentMethodSubType,
      txnAmount,
      platformFee,
      splitData: any,
    ) {
      let response
      const PAYMENT_MODE_SUBTYPES: any = {
        UPI: 566,
        NB: 581,
        CARD: 582,
        WALLET: 579,
        CARDLESS_EMI: 600,
        EMI: 114, //TYPE
        PAYLATER: 601,
        FOOD_CARD: 613,
        NATIVE_UPI: 580,
        CORP_NB: 620,
        NEW_TO_CREDIT: 619,
        UPI_SUBSCRIPTION: 589,
        CARD_SUBSCRIPTION: 590,
      }
      const isPlatformFeeAdded = platformFee > 0
      try {
        const splitSettlments = splitData?.map((item, index) => {
          // const itemPlatformFee = isPlatformFeeAdded ? +Number(platformFee / splitData?.length)?.toFixed(2) : 0
          return {
            entityType: BENEFICIARY_ENTITY_TYPE,
            entityId: item?.id,
            grossAmount: +item?.splitAmount, //+Number(item?.splitAmount + itemPlatformFee)?.toFixed(2),
            netAmount: +item?.splitAmount,
            invoice: `INV000${index + 1}`,
            platformFee: false,
            // platformFeeValue: isPlatformFeeAdded ? itemPlatformFee: undefined,
          }
        })
        const platformFeeObj = {
          entityType: PLATFORM_FEE_ENTITY_TYPE,
          entityId: RootStore.user.selectedMid,
          grossAmount: platformFee,
          netAmount: platformFee,
          invoice: self?.details?.ern,
          platformFee: false,
        }
        const { REACT_APP_CHANNEL_ID = '' } = window?._env_ ?? {}
        const req = {
          transaction: {
            idempotentKey: getRandomAlphaNumString(32),
            originalId: txnId,
            initiatingEntityTimestamp: dateToLocaleISO(new Date()),
            initiatingEntity: {
              entityId: REACT_APP_CHANNEL_ID,
            },
            metadata: { payoutDetails: isPlatformFeeAdded ? [...splitSettlments, platformFeeObj] : splitSettlments },
            currency: 356,
            livemode: 'true',
            invoice: `INV_SPLIT_PAYOUT_${txnId}`,
            method: { type: 312, subType: PAYMENT_MODE_SUBTYPES[paymentMethodSubType] },
            mode: 1,
            application: 8006,
          },
          amount: { netAmount: txnAmount, grossAmount: txnAmount },
          payee: { merchantId: RootStore.user.selectedMid, type: 12 },
        }
        response = yield splitSettlements(RootStore.user.session.getTokens, RootStore.user.session.userAccessToken, req)
        if (response?.data?.transaction?.failureMessage?.length > 0) {
          RootStore?.response?.setMessage(response?.data?.transaction?.failureMessage ?? customError.errorOccured)
        } else {
          RootStore?.response?.setMessage(response?.data?.transaction?.status)
          RootStore?.response?.setToastType('POSITIVE')
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
    updatePagination(selectedPage: number): void {
      self.pagination.number = selectedPage
    },
    updatePaginationNativeReceived(page: number): void {
      self.paginationRecived.number = page
    },
    updatePaginationNativeRefunded(page: number): void {
      self.paginationRefunded.number = page
    },
    resetPagination(): void {
      self.filter.updateAllFieldsSelected(false)
      self.pagination = JSON.parse(JSON.stringify(paginationSettingsWithDefaultPage1))
    },
    resetPaginationNativeRecieved(): void {
      self.filter.updateAllFieldsSelected(false)
      self.paginationRecived = JSON.parse(JSON.stringify(paginationSettingsWithDefaultPage1))
    },
    resetPaginationNativeRecievedToZero(): void {
      self.filter.updateAllFieldsSelected(false)
      self.paginationRecived = JSON.parse(JSON.stringify(paginationSettings))
    },
    resetPaginationNativeRefundedToZero(): void {
      self.filter.updateAllFieldsSelected(false)
      self.paginationRefunded = JSON.parse(JSON.stringify(paginationSettings))
    },
    resetPaginationNativeRefunded(): void {
      self.filter.updateAllFieldsSelected(false)
      self.paginationRefunded = JSON.parse(JSON.stringify(paginationSettingsWithDefaultPage1))
    },
    resetPaginationNative(): void {
      self.filter.updateAllFieldsSelected(false)
      self.paginationRecived = JSON.parse(JSON.stringify(paginationSettingsWithDefaultPage1))
      self.paginationRefunded = JSON.parse(JSON.stringify(paginationSettingsWithDefaultPage1))
    },
    updateFieldSettings(newSettings: any): void {
      const own = self
      own.fieldSetting = JSON.parse(JSON.stringify([...newSettings]))
    },
    applyFieldSettings(newSettings: string[]): void {
      const own = self
      const newFields =
        own?.fieldSetting.map((item) => {
          if (newSettings.includes(item?.id)) {
            item.isChecked = true
          } else {
            item.isChecked = false
          }
          return item
        }) ?? []
      own.fieldSetting = JSON.parse(JSON.stringify(newFields))
    },
    updateFieldSetting(newSetting: string): void {
      const own = self
      const newFields: any = []
      own?.fieldSetting.map((item) => {
        if (newSetting === item?.id) {
          item.isChecked = true
        }
        newFields.push(item)
        return item
      }) ?? []
      own.fieldSetting = JSON.parse(JSON.stringify(newFields))
    },
    setSelectionNew(data: any): void {
      const own = self
      const newSelection = own.fieldSetting.map((item) => {
        const Item = item
        if (Item.id === data) {
          Item.isChecked = !Item.isChecked
        }
        return Item
      })
      own.fieldSetting = JSON.parse(JSON.stringify([...newSelection]))
    },
    resetFilters(): void {
      const own = self
      const defaultFilters = {
        min: '',
        max: '',
        transactionStatus: [],
        paymentMode: [],
        paymentLinkStatus: 'ALL',
        contact: '',
        email: '',
        paymentLinkId: '',
        merchantLinkId: '',
        amount: '',
        invoiceNumber: '',
        subscriptionStatus: [],
        subscriptionRevocable: '',
        subscriptionSearch: '',
        subscriptionSearchType: '',
        subscriptionStartDate: '',
        subscriptionDateType: '',
        subscriptionEndDate: '',
        campaignType: ['All', 'Instant Discount', 'Cashback'],
        campaignStatus: ['All', 'Active', 'Paused', 'Scheduled', 'Completed'],
        mid: [],
      }
      own.filter = JSON.parse(JSON.stringify(defaultFilters))
    },
    resetTxnHistory() {
      const own = self
      own.history = JSON.parse(JSON.stringify([]))
      own.pagination = paginationSettingsWithDefaultPage1
    },
  }))
  .views((self) => ({
    newTransactionDetails(txnType = Routes.TRANSACTIONS): any {
      return transactionDetailsParser(self.details, txnType)
    },
    fetchTransaction(byScreen = Routes.TRANSACTIONS, isMobile: boolean): any[] {
      if (isMobile) {
        switch (byScreen) {
          case Routes.TRANSACTIONS: {
            const trxn = transactionFilterMobileTableParser(
              self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Transaction),
            )
            const size = trxn.length
            if (size === 0) {
              return []
            }
            return [...trxn.slice(0)]
          }

          case Routes.REFUNDS: {
            const trxn = refundMobileTableParser(
              self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Refund),
            )
            const size = trxn.length
            if (size === 0) {
              return []
            }
            return [...trxn.slice(0)]
          }

          default:
            return []
        }
      }
      switch (byScreen) {
        case Routes.TRANSACTIONS: {
          const trxn = transactionFilterTableParserNew(
            self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Transaction),
            self.fieldSetting,
            RootStore.settings.metaData.isSplitSettlementsEnabled,
          )
          const size = trxn.length
          if (size === 1) {
            return []
          }
          return [...trxn.slice(0)]
        }

        case Routes.REFUNDS: {
          const trxn = transactionFilterTableParserNew(
            self.history.filter((obj: any) => obj.get('txnType') === TransactionTypes.Refund),
            REFUND_FIELD_SETTINGS_DATA.filter((field) => REFUND_FIELD_SETTINGS.includes(field.id)).map((item) => ({
              ...item,
              isChecked: true,
              isDisable: true,
            })),
            RootStore.settings.metaData.isSplitSettlementsEnabled,
          )
          const size = trxn.length
          if (size === 1) {
            return []
          }
          return trxn
        }
        case Routes.INITIATEREFUNDS: {
          let trxs: RefundProcessed[] = []
          const selectedTransactions: any[] = []
          self.history.forEach((item) => {
            if (item.get('transactionId') === self.selectedTxn) {
              selectedTransactions.push(JSON.parse(JSON.stringify(item)))
            }
          })
          trxs = refundConfirmTableParser(selectedTransactions)
          return [refundsProcessedTitleData, ...trxs]
        }
        default:
          return []
      }
    },
    fetchDataForTransactionTab(byScreen = Routes.TRANSACTIONS): any[] {
      switch (byScreen) {
        case Routes.TRANSACTIONS: {
          const trxn = transactionFilterMobileTableParser(
            self.received.filter((obj) => obj.txnType === TransactionTypes.Transaction),
          )
          const size = trxn.length
          if (size === 0) {
            return []
          }
          return [...trxn.slice(0)]
        }

        case Routes.REFUNDS: {
          const trxn = refundMobileTableParser(self.refunded.filter((obj) => obj.txnType === TransactionTypes.Refund))
          const size = trxn.length
          if (size === 0) {
            return []
          }
          console.log('value', [...trxn.slice(0)])
          return [...trxn.slice(0)]
        }

        default:
          return []
      }
    },

    getSelectedTransactions(): any[] {
      const trxs = refundInitiateTableParser(self.details)
      return [trxs.paymentMode === 'Sodexo' ? initiateRefundTitleDataSodexoV2 : initiateRefundTitleDataV2, trxs] // remvoing header
    },

    getSelectedRefundAmount() {
      const selectedTxn = self.history.filter((item: any) => self.selectedTxn === item.get('transactionId'))?.[0]
      const txnAmount = selectedTxn?.get('processed') ?? 0
      return parseFloat(String(txnAmount)).toFixed(2)
    },

    getRefundStatus(): any[] {
      const trxs = refundStatusParser([self.details])
      return [initiateRefundStatusDataV2, ...trxs.slice(0, 1)] // remvoing header
    },

    getSlectedRRNs(): string {
      return self.selectedTxn
    },

    fetchRecentTranasctions(byTab = Routes.TRANSACTIONS, isMobile: boolean): any[] {
      if (isMobile) {
        const switcher = byTab?.toLowerCase()
        switch (switcher) {
          case 'received': {
            const trxn = transactionFilterMobileTableParser(
              self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Transaction).slice(0, 10),
            )
            if (trxn.length === 0) {
              return []
            }
            return [...trxn]
          }

          case 'refunded': {
            const trxn = refundMobileTableParser(
              self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Refund).slice(0, 10),
            )
            if (trxn.length === 0) {
              return []
            }
            return [...trxn]
          }

          default:
            return []
        }
      }
      switch (byTab) {
        case Routes.TRANSACTIONS: {
          const trxn = transactionRecentsTableParse(
            self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Transaction).slice(0, 10),
          )
          if (trxn.length === 0) {
            return []
          }
          return [...trxn]
        }

        case Routes.REFUNDS: {
          const trxn = refundsRecentsTableParser(
            self.history.filter((obj: any) => obj.get('txnType') === TransactionTypes.Refund).slice(0, 10),
          )
          if (trxn.length === 0) {
            return []
          }
          return [...trxn]
        }

        default:
          return []
      }
    },
    fetchRecentTranasctionsForMobile(byTab = Routes.TRANSACTIONS): any[] {
      const switcher = byTab?.toLowerCase()
      switch (switcher) {
        case 'received': {
          const trxn = transactionFilterMobileTableParser(
            self.todaysRecived.filter((obj) => obj.txnType === TransactionTypes.Transaction).slice(0, 10),
          )
          if (trxn.length === 0) {
            return []
          }
          return [...trxn]
        }

        case 'refunded': {
          const trxn = refundMobileTableParser(
            self.todaysRefunded.filter((obj) => obj.txnType === TransactionTypes.Refund).slice(0, 10),
          )
          if (trxn.length === 0) {
            return []
          }
          return [...trxn]
        }

        default:
          return []
      }
    },
    newFetchHoverTableData(): any[] {
      if (self.details === undefined) {
        return []
      }
      return refundHistoryParser(JSON.parse(JSON.stringify(self.details)))
    },
    getAllTransactions(): any[] {
      return transactionFilterTableParserNew(
        self.history.filter((obj) => obj.get('txnType') === TransactionTypes.Transaction),
        self.fieldSetting,
      )
    },
    getAllRefundTransactions(): any[] {
      return initRefundsTableParser(
        self.history.filter(
          (obj: any) =>
            obj.get('txnType') === TransactionTypes.Transaction &&
            (obj.get('transactionDisposition') ?? '').toLowerCase() === 'success' &&
            (obj?.get('transactionAmount') ?? '') > (obj?.get('refundAmount') ?? ''),
        ),
      )?.slice(1)
    },
    getSearchData(data: any, text: string): any[] {
      const parsedSearchData: any[] = []
      const getRanking: any = {
        ERN: 2,
        date: 1,
      }
      data?.filter((item: any) => {
        const tempSearchData: any[] = []
        const txnValues = Object?.values(item)
        const keyValues = Object?.keys(item)
        txnValues.map((element, index) => {
          const searchItem = {
            id: item?.id,
            value: typeof element === 'string' ? element : '',
            key: keyValues[index],
            iconId: 'SEARCH',
            styledText: text,
            rank: getRanking[keyValues[index]] || 0,
          }
          tempSearchData.push(searchItem)
          return searchItem
        })
        const sortedSearchData = tempSearchData.sort((tempSearchData1, tempSearchData2) => {
          const rank1 = tempSearchData1?.rank
          const rank2 = tempSearchData2?.rank
          const result = rank2 - rank1
          return result
        })
        const sData = sortedSearchData.filter((tempItem) =>
          tempItem?.value?.toLowerCase()?.includes(text.toLowerCase()),
        )

        const searchListDefaultsArray: any[] = []
        if (sData.length > 0) {
          sortedSearchData.forEach((sortedItem) => {
            if (sortedItem.rank > 0 && searchListDefaultsArray.length <= 2) {
              searchListDefaultsArray.push(sortedItem)
            }
          })
        }
        const searchListArray: any[] = []
        if (sData.length > 0) {
          sData.forEach((sItem) => {
            if (sItem.rank === 0 && searchListArray.length === 0) {
              searchListArray.push(sItem)
            }
          })
        }
        const final = searchListDefaultsArray.concat(searchListArray)

        sData.length > 0 && parsedSearchData.push(final)
        return parsedSearchData
      })
      return parsedSearchData
    },
    getALLFields(): any {
      const fieldsdata = self.fieldSetting.slice()
      return fieldsdata
    },
    getCheckedColumn(): any[] {
      let Columns: any[] = []
      self.fieldSetting.forEach((item) => {
        if (item.isChecked === true) {
          Columns.push(item)
        }
      })
      const columnsdata = Columns.reduce((obj, item) => Object.assign(obj, { [item.id]: item.isChecked }), {})
      return Object.keys(columnsdata)
    },
    get isFieldsNotEmpty(): boolean {
      return self.fieldSetting.length > 0 ? true : false
    },
    selectAllFields(value: boolean): any {
      const own = self
      const newFields =
        own?.fieldSetting.map((item) => {
          if (item.isDisable) {
            return item
          } else {
            return {
              ...item,
              isChecked: value,
            }
          }
        }) ?? []
      return JSON.parse(JSON.stringify(newFields))
    },
  }))
  .views((self) => ({
    getTxnDetilsKeyValues(_transactionId: string, path: string): any {
      return txnDetailsMobileParser(self.details, path)
    },
    getTxnDetilsValues(_transactionId: string, path: string): any {
      const txnDetails = txnDetailsMobileParser(self.details, path)
      return Object.values(txnDetails)
    },
    getTxnRemainingAmtToRefund(): string {
      const txnAmount = self?.details?.amount ?? 0
      const refundedAmount = self?.details?.refund?.amount ?? 0
      const remAmt = txnAmount - refundedAmount
      return parseFloat(String(remAmt)).toFixed(2)
    },
    getSelectedTxnRemainingAmtToRefund(): string {
      const selectedTxn = self.history.filter((item: any) => self.selectedTxn === item.get('transactionId'))?.[0]
      const txnAmount = selectedTxn?.get('transactionAmount') ?? 0
      const refundedAmount = selectedTxn?.get('refundAmount') ?? 0
      const remAmt = +txnAmount - +refundedAmount
      return parseFloat(String(remAmt)).toFixed(2)
    },
    getOriginalId(txnId: any): string {
      let originId = ''
      const iteratingArray = [
        ...self.history,
        ...self.received,
        ...self.refunded,
        ...self.todaysRecived,
        ...self.todaysRefunded,
      ]
      iteratingArray.some((item: any) => {
        if (item.id === txnId) {
          originId = item.originalTransactionId === '' ? item.rrn : item.originalTransactionId
          return true
        }
        return false
      })
      return originId
    },
  }))
const transactionsData: any = Transactions.create({
  history: [],
  filter: defaultSelectedFilters,
  receivedFilter: defaultSelectedFilters,
  refundFilter: defaultSelectedFilters,
  selectedTxn: '',
  pagination: paginationSettingsWithDefaultPage1,
  paginationRecived: paginationSettingsWithDefaultPage1,
  paginationRefunded: paginationSettingsWithDefaultPage1,
  fieldSetting: [],
  selectedDateInfo: {
    fromDate: getSelectedDate(1),
    toDate: new Date(Date.now()),
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
    dateLabel: 'Today',
  },
  receivedSelectedDateInfo: {
    fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
    toDate: new Date(Date.now()),
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
    dateLabel: actionMenuStrings?.infiniteScrollRange,
  },
  refundedSelectedDateInfo: {
    fromDate: getSelectedDate(INFINITE_SCROLL_WINDOW_INDEX),
    toDate: new Date(Date.now()),
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
    dateLabel: actionMenuStrings?.infiniteScrollRange,
  },
  exportStatementDateInfo: {
    fromDate: getSelectedDate(1),
    toDate: new Date(Date.now()),
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
    dateLabel: actionMenuStrings?.today,
  },
})
export { Transaction, Transactions, transactionsData }
export type TransactionType = Instance<typeof Transaction>
export type FieldsType = Instance<typeof FieldSetting>
